import ReactModal from "react-modal";
import { BoxModal } from "../../boxModal";

export const ConfigMode = ({isConfigMode, handleBackToCardList, isPagarAtivado, togglePaySwitch, handleSave }) => (
  <ReactModal
    isOpen={isConfigMode}
    className="manage-card-modal"
    overlayClassName="overlay-manage-card-modal"
  >
    <BoxModal
      maxWidth={500}
      title="Configurações do Cartão"
      close={handleBackToCardList}
    >
      <div className="config-option">
        <span className="text-managedCard">Pagar por aproximação</span>
        <div className="switch">
          <input
            type="checkbox"
            checked={isPagarAtivado}
            onChange={togglePaySwitch}
            id="pagarSwitch"
          />
          <label htmlFor="pagarSwitch"></label>
        </div>
      </div>
      <div className="modal-footer">
        <button 
          type="button" 
          className="btn btn-outline-secondary" 
          onClick={handleBackToCardList}
        >
          Fechar
        </button>
        <button 
          type="button" 
          className="btn btn-success" 
          onClick={handleSave}
        >
          Salvar
        </button>
      </div>
    </BoxModal>
  </ReactModal>
);
